import clsx from "clsx";
import * as React from "react";
import { FiltersProps } from ".";

const Filters: React.FC<FiltersProps> = (props) => {
    const updateFilter = (box: any): void => {
        let newFilters = [...props.filters];

        newFilters = newFilters.map((item) => {
            if (item.repeater_index === box._id) {
                item.active = !item.active;
            }

            return item;
        });

        props.setFilters(newFilters);
    };

    return (
        <div className="tmp-find-dealer__filters">
            {props.settings.filter_boxes?.map((box, index) => (
                <div
                    key={index}
                    className={clsx("tmp-find-dealer__filters__item", {
                        "tmp-active": props.filters.some(
                            (item) => item.repeater_index === box._id && item.active
                        ),
                    })}
                    onClick={(e) => {
                        updateFilter(box);
                    }}
                >
                    {box.filter_box_icon?.url && (
                        <div
                            className="tmp-find-dealer__filters__item__icon"
                            style={{ backgroundImage: "url(" + box.filter_box_icon.url + ")" }}
                        />
                    )}
                    <div className="tmp-find-dealer__filters__item__title">
                        {box.filter_box_title}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Filters;
